/* eslint-disable no-unused-vars */

const CONFIG2 = {
  selectedClass: "selected",
}
class NewPersonalizer extends HTMLElement {
  currentStep = 0;
  connectedCallback() {
    this.setData();
    this.getElement();
    this.addEventModal();
    this.initSwiper();
    this.addEventButton();
    this.addEventButtonAtc();
    this.updateButtonPrice();
    this.updateProperties();
    this.updateCartItem();
    this.addEventOffer();
  }

  setData() {
    this.productHandle = this.getAttribute("data-product-handle");
    this.productHandleModal = this.getAttribute("data-product");
    this.steps = this.querySelectorAll('[new-step]');
    this.totalStep = this.steps.length;

    this.items = [];
    this.extraItems = [];
    this.properties = {};
  }

  getElement() {
    this.buttonCustomize = document.querySelector(".js-button-customize");
    this.innerEl = this.querySelector(".js-personalizer-inner");
    this.buttonClose = this.querySelector(".js-button-close");
    this.overlay = this.querySelector(".js-overlay");

    this.variantId = this.querySelector(".js-variant-id");
    this.buttonAtcs = this.querySelectorAll(".js-button-atc");
    this.buttonPriceEl = this.querySelector(".js-button-price");
  }

  addEventModal() {
    this.buttonCustomize.addEventListener("click", (e) => {
      e.preventDefault();
      const _productHandle = this.buttonCustomize.dataset.handle;
      if (this.productHandleModal !== _productHandle) {
        return;
      }
      this.classList.add("open");
    });
    this.buttonClose.addEventListener("click", () => {
      this.closeModal();
    });
    this.overlay.addEventListener("click", () => {
      this.closeModal();
    });
  }

  initSwiper() {
    this.swiperEl = this.querySelector("swiper-container");

    this.addEventListener("updateNameSlides", (e) => {
      const number = e.detail.number;
      for (let i = 1; i <= 5; i++) {
        const nameSlide = this.swiperEl.querySelector(`swiper-slide[data-type="name"][data-index="${i}"]`);
        nameSlide.classList.remove("hidden");
        if (i > number) {
          nameSlide.classList.add("hidden");
        }
      }
    })
  }

  goToStep({step, type = "next"}) {
    if (type === "next") {
      this.currentStep += 1;
    } else {
      this.currentStep -= 1;
    }

    this.swiperEl.swiper.slideTo(this.currentStep);

    // Object.keys(this.steps).forEach((key) => {
    //   this.classList.remove(key);
    // });
    // this.classList.add(this.currentStep);
  }

  addEventButton() {
    const buttons = this.querySelectorAll(".js-button");
    buttons?.forEach((button) => {
      button.addEventListener("click", () => {
        const type = button.dataset.type;
        const step = button.dataset.step;
        this.goToStep({type, step});
      });
    });
  }

  updateButtonPrice() {
    if (!this.buttonPriceEl) {
      return;
    }

    this.addEventListener("changedNameSelect", (e) => {
      const price = e.detail.price;
      this.buttonPriceEl.dataset.namePrice = price;
      this.calculateButtonPrice();
    })

    document.addEventListener("extraSelected", (e) => {
      const price = e.detail.price;
      this.buttonPriceEl.dataset.extraPrice = price;
      this.calculateButtonPrice();
      this.buttonAtcs.forEach((buttonAtc) => {
        buttonAtc.disabled = false;
      });
    });
  }

  calculateButtonPrice() {
    const currentPrice = this.buttonPriceEl.dataset.price || 0;
    const namePrice = this.buttonPriceEl.dataset.namePrice || 0;
    const extraPrice = this.buttonPriceEl.dataset.extraPrice || 0;

    this.buttonPriceEl.textContent = formatMoney(parseFloat(currentPrice) + parseFloat(extraPrice) + parseFloat(namePrice));
  }

  updateProperties() {
    this.addEventListener("updateProperties", (e) => {
      const properties = e.detail.properties;
      this.properties = {
        ...this.properties,
        ...properties,
      }
      // null = "remove this property" (a birthstone that was deselected)
      Object.keys(properties || {}).forEach((k) => { if (properties[k] === null) delete this.properties[k]; });
    });
  }

  updateCartItem() {
    const _this = this;

    this.addEventListener("updateCartItem", (e) => {
      const item = e.detail.item;
      _this.items = [item]
    });

    this.addEventListener("updateExtraCartItem", () => {
      _this.extraItems = [];
      const extraItemsEls = _this.querySelectorAll(`.js-extra-item.${CONFIG2.selectedClass}`);

      extraItemsEls.forEach((extraItem) => {
        const variantId = extraItem.dataset.variant;
        const itemCart = {
          id: variantId,
          properties: {},
          quantity: 1,
        }
        _this.extraItems = [
          ..._this.extraItems,
          itemCart,
        ]
      });
    });
  }

  validateAtc() {
    const validateEls = this.querySelectorAll(".js-validation");

    if (validateEls.length === 0) {
      return false;
    }

    let hasError = false;
    validateEls.forEach((el) => {
      const selectEl = el.querySelector(".js-select");
      const valueSelected = selectEl.querySelector(".js-select-value").dataset.value;
      if (!valueSelected) {
        hasError = true;
        el.classList.add("custom-select--error");
      } else {
        el.classList.remove("custom-select--error");
      }
    });

    return hasError;
  }

  addEventButtonAtc() {
    this.buttonAtcs.forEach((buttonAtc) => {
      buttonAtc.addEventListener("click", () => {
        const hasValidate = buttonAtc.dataset.hasValidate;
        if (hasValidate === "true") {
          const validate = this.validateAtc()

          if (validate) {
            return;
          }
        }

        const buttonTextEl = buttonAtc.querySelector(".js-button-text");
        const buttonText = buttonTextEl.textContent;
        buttonAtc.disabled = true;
        buttonTextEl.textContent = "Adding...";
        const url = buttonAtc.dataset.url;
        const handle = buttonAtc.dataset.handle;
        const nextStep = buttonAtc.dataset.nextStep;

        let variantId = this.variantId.value;

        const items = [
          ...this.items.map((item) => ({
            ...item,
            properties: {
              ...item.properties,
              _parent: this.productHandle,
            },
          })),
          ...this.extraItems.map((item) => ({
            ...item,
            properties: {
              ...item.properties,
              _parent: this.productHandle,
            },
          })),
          {
            id: variantId,
            properties: this.properties,
            quantity: 1,
          }
        ]

        const data = {
          'items': items
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then(async (data) => {
            buttonTextEl.textContent = "Added to cart";
            buttonAtc.disabled = false;

            // fetch data cart
            const cartData = await fetch("/cart.js", {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                }
              })
            const cartDataJson = await cartData.json()
            let mainItem = 0
            cartDataJson.items.forEach(item => {
              if (!item?.properties?._parent && !item?.properties?._card) {
                mainItem = mainItem + item.quantity;
              }
            });
            setTimeout(() => {
              if (!handle && !nextStep) {
                window.location.href = url;
              } else {
                if (nextStep === "final") {
                  this.dispatchEvent(new CustomEvent("update-progress", {
                    detail: {
                      step: mainItem,
                    },
                  }));
                  this.goToStep("final");
                } else {
                  this.closeModal();
                  this.resetAll();
                  this.openModal(handle);
                }

              }
              buttonTextEl.textContent = buttonText;
            }, 1000);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
    });
  }

  addEventOffer() {
    this.buttonOfferEls = this.querySelectorAll(".js-button-offer");
    if (this.buttonOfferEls?.length === 0) {
      return;
    }

    this.buttonOfferEls?.forEach((buttonOffer) => {
      buttonOffer.addEventListener("click", () => {
        const template = buttonOffer.dataset.template;
        const url = buttonOffer.dataset.url;
        const handle = buttonOffer.dataset.handle;

        if (template.indexOf('personalizer-inline') !== -1) {
          window.location.href = url;
        } else {
          const modal = document.querySelector(
            `.js-personalizer[data-product="${handle}"]`
          );
          if (!modal && url) {
            window.location.href = url;
          }

          if (modal) {
            this.closeModal();
            this.resetAll();
            this.openModal(handle, url);
          }
        }
      });
    });
  }

  closeModal() {
    this.classList.remove("open");
  }

  resetAll() {
    // this.properties = {
    //   color: "",
    //   chain: "",
    //   name: "",
    // };
    // this.currentStep = 0;
    // this.resetStep("color");
    // if (this.hideChain !== "true") {
    //   this.resetStep("chain");
    // }
    // if (this.hideExtra !== "true") {
    //   this.resetStep("extra");
    // }
    // this.resetStep("name");
    // this.goToStep("color");
    // this.validateButton();
  }

  openModal(handle, url = null) {
    const modal = document.querySelector(
      `.js-personalizer[data-product="${handle}"]`
    );

    if (modal) {
      modal.classList.add("open");
    }

    if (!modal && url) {
      window.location.href = url;
    }
  }
}

customElements.define("new-personalizer", NewPersonalizer);

class NewColor extends HTMLElement {
  connectedCallback() {
    this.newPersonalizer = this.closest(".js-personalizer");

    this.selectedColorEl = this.querySelector(".js-color-selected");
    this.colors = Array.prototype.slice.call(this.querySelectorAll(".js-color-item"));
    this.colorMessageEl = this.querySelector('.js-color-message')

    this.colors?.forEach((color) => {
      color.addEventListener("click", () => {
        this.removeSelectedClass();
        color.classList.add(CONFIG2.selectedClass);
        this.selectedColorEl.textContent = color.dataset.color;
        this.updateProperties(color.dataset.color)
        this.validateButton();

        if (this.colorMessageEl) {
          this.colorMessageEl.setAttribute('data-color', color.dataset.color)
        }
      });
    });
  }

  updateProperties(value) {
    const properties = {
      'Color': value,
    }

    this.newPersonalizer.dispatchEvent(new CustomEvent("updateProperties", {
      detail: {
        properties
      },
    }));
  }

  removeSelectedClass() {
    this.colors?.forEach((color) => {
      color.classList.remove(CONFIG2.selectedClass);
    });
  }

  validateButton () {
    const button = this.querySelector(".js-button");
    button.disabled = !this.colors?.some((color) => color.classList.contains(CONFIG2.selectedClass));
  }
}

customElements.define("new-color", NewColor);

class NewNameSelect extends HTMLElement {
  connectedCallback() {
    this.previewImageEl = this.querySelector(".js-preview-image");
    this.selectedNameEl = this.querySelector(".js-name-selected");
    this.names = Array.prototype.slice.call(this.querySelectorAll(".js-name-item"));

    this.newPersonalizer = this.closest(".js-personalizer");

    this.names?.forEach((name) => {
      name.addEventListener("click", () => {
        const previewImage = name.dataset.image;
        if (this.previewImageEl && previewImage) {
          this.previewImageEl.src = previewImage;
        }

        const number = name.dataset.index;
        this.newPersonalizer.dispatchEvent(
          new CustomEvent("updateNameSlides", {
            bubbles: true,
            detail: {
              number,
            },
          }),
        );

        const charmId = name.value;
        const charmPrice = name.dataset.price;
        this.newPersonalizer.dispatchEvent(
          new CustomEvent("changedNameSelect", {
            bubbles: true,
            detail: {
              price: charmPrice,
            },
          }),
        );

        this.updateCartItem(charmId);
        this.validateButton();
      });
    });
  }

  updateCartItem(charmId) {
    const item = {
      id: charmId,
      properties: {},
      quantity: 1,
    }

    this.newPersonalizer.dispatchEvent(new CustomEvent("updateCartItem", {
      detail: {
        item,
      },
    }));
  }

  validateButton () {
    const button = this.querySelector(".js-button[data-type='next']");

    button.disabled = !this.names?.some((name) => !!name.checked);
  }
}

customElements.define("new-name-select", NewNameSelect);

class NewName extends HTMLElement {
  connectedCallback() {
    this.newPersonalizer = this.closest(".js-personalizer");

    this.nameEl = this.querySelector(".js-personalizer-name");
    this.buttonNextEl = this.querySelector(".js-button[data-type='next']");
    this.index = this.nameEl.dataset.index;

    this.nameEl.addEventListener("input", () => {
      this.validateButton();
      this.updateProperties(this.nameEl.value);
    });
  }

  updateProperties(value) {
    const properties = {
      [`Name ${this.index}`]: value,
    }

    this.newPersonalizer.dispatchEvent(new CustomEvent("updateProperties", {
      detail: {
        properties
      },
    }));
  }

  validateButton () {
    this.buttonNextEl.disabled = !this.nameEl.value;
  }
}

customElements.define("new-name", NewName);

function formatMoney(cents, formatString = Shopify.money_format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    const parts = number.split("."),
      dollars = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
